import API from '../../shared/Config/API';
import APIEndpoints from '../../shared/Config/APIEndpoints';

const fetchUsers = async () => {
  try {
    return await API.get(APIEndpoints.GET_USERV2);
  } catch (error) {
    console.error(error);
  }
};

export const usersApi = {
  fetchUsers,
};
